import userRouteConfig from './user/userRouteConfig';
import fejezetRouteConfig from './fejezet/fejezetRouteConfig';
import esetleirasRouteConfig from './esetleiras/esetleirasRouteConfig';
import tobbszoroskerdesRouteConfig from './tobbszoroskerdes/tobbszoroskerdesRouteConfig';
import relacioanaliziseskerdesRouteConfig from './relacioanaliziseskerdes/relacioanaliziseskerdesRouteConfig';
import asszociacioskerdesRouteConfig from './asszociacioskerdes/asszociacioskerdesRouteConfig';
import valaszRouteConfig from './valasz/valaszRouteConfig';
import egyszerukerdesRouteConfig from './egyszerukerdes/egyszerukerdesRouteConfig';
import fileManagerRouteConfig from './fileManager/fileManagerRouteConfig';
import vizsgaRouteConfig from './vizsga/vizsgaRouteConfig';
import vizsgaFeladatsorRouteConfig from './vizsgaFeladatsor/vizsgaFeladatsorRouteConfig';
import vizsgaFeladatRouteConfig from './vizsgafeladat/vizsgaFeladatRouteConfig';
import vizsgazoRouteConfig from './vizsgazo/vizsgazoRouteConfig';
import uzenetRouteConfig from './uzenet/uzenetRouteConfig';
import kerdesRouteConfig from './kerdes/kerdesRouteConfig';
import vonalkodtesztlapRouteConfig from './vonalkodtesztlap/vonalkodtesztlapRouteConfig';
import vonalkodadatlapRouteConfig from './vonalkodadatlap/vonalkodadatlapRouteConfig';
import tesztlapokRouteConfig from './tesztlapok/tesztlapokRouteConfig';
import racstesztlapRouteConfig from './racstesztlap/racstesztlapRouteConfig';
import feltoltestesztlapRouteConfig from './feltoltestesztlap/feltoltestesztlapRouteConfig';
import feltoltesadatlapRouteConfig from './feltoltesadatlap/feltoltesadatlapRouteConfig';
import parositasadatlapRouteConfig from './parositasadatlap/parositasadatlapRouteConfig';
import reviewRouteConfig from './review/reviewRouteConfig';
import userGroupConfig from './userGroup/userGroupConfig';
import feladatCsoportRouteConfig from './feladatCsoport/feladatCsoportRouteConfig';
import profileRouteConfig from './profile/profileRouteConfig';

const AdminConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		...fileManagerRouteConfig,
		...userRouteConfig,
		...fejezetRouteConfig,
		...esetleirasRouteConfig,
		...tobbszoroskerdesRouteConfig,
		...relacioanaliziseskerdesRouteConfig,
		...asszociacioskerdesRouteConfig,
		...valaszRouteConfig,
		...egyszerukerdesRouteConfig,
		...fileManagerRouteConfig,
		...vizsgaRouteConfig,
		...vizsgaFeladatsorRouteConfig,
		...vizsgazoRouteConfig,
		...uzenetRouteConfig,
		...vizsgaFeladatRouteConfig,
		...kerdesRouteConfig,
		...vonalkodtesztlapRouteConfig,
		...vonalkodadatlapRouteConfig,
		...tesztlapokRouteConfig,
		...racstesztlapRouteConfig,
		...feltoltestesztlapRouteConfig,
		...feltoltesadatlapRouteConfig,
		...parositasadatlapRouteConfig,
		...reviewRouteConfig,
		...userGroupConfig,
		...feladatCsoportRouteConfig,
		...profileRouteConfig
	]
};

export default AdminConfig;
